
import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors } from '../../../ui';
import { BadgeButton, BadgeButtonProps } from '../../../ui/BadgeButton';
import { Flexer } from '../elements/LayoutElements';

const External = styled.div`
    position: absolute;
    left: 100%;
    top: 50%;
    opacity: 0;
    transform: translate(0%, -50%);
    transition: opacity .1s ease-in-out, transform .1s ease-in-out;

    ${BadgeButton}:hover & {
        opacity: 1;
        transform: translate(25%, -50%);
    }
`;

export type BoardBadgeButtonProps = Omit<BadgeButtonProps, 'color'> & { label: string, href: string };

export const BoardBadgeButton = React.memo<BoardBadgeButtonProps>(({ label, href, ...buttonProps }) => {
    return <a href={href} target="_blank" rel="noreferrer">
        <BadgeButton {...buttonProps} color={Colors.gray100}>
            <Icon size="1.25" src="deqo://icons/dash/board" />
            <Flexer margin="0 0 0 0.125">
                {label}
            </Flexer>
            <External>
                <Icon size="1" src="deqo://icons/hero/external-link" />
            </External>
        </BadgeButton>
    </a>;
});
